export default __webpack_public_path__ + "static/media/copy.c539cc6d.svg";